import type { AssetGroup } from 'querys/regional-overview/regional-overview.query.models';
import { create } from 'zustand';
import type { NetworkTrapRow } from './network-management.models';

interface NetworkManagementStore {
  isModalOpen: boolean;
  trapName: string;
  trapId: string;
  coordinates: number[];
  editingGroup?: AssetGroup;
  selectedTrapIDs: string[];
  selectedTraps: NetworkTrapRow[];
  selectedPestEppoCode?: string;

  setIsModalOpen: (isModalOpen: boolean) => void;
  setTrapName: (trapName: string) => void;
  setTrapId: (trapId: string) => void;
  setCoordinates: (coordinates: number[]) => void;
  setEditingGroup: (editingGroup?: AssetGroup) => void;
  setSelectedTraps: (selectedTraps: NetworkTrapRow[]) => void;
  reset: () => void;
}

const getInitialState = () => ({
  isModalOpen: false,
  trapName: '',
  trapId: '',
  coordinates: [0, 0],
  editingGroup: undefined,
  selectedTrapIDs: [],
  selectedTraps: [],
  selectedPestEppoCode: undefined
});

export const useNetworkManagementStore = create<NetworkManagementStore>(set => ({
  ...getInitialState(),
  setIsModalOpen: isModalOpen => set({ isModalOpen }),
  setTrapName: trapName => set({ trapName }),
  setTrapId: trapId => set({ trapId }),
  setCoordinates: coordinates => set({ coordinates }),
  setEditingGroup: editingGroup => set({ editingGroup }),
  setSelectedTraps: selectedTraps =>
    set({
      selectedTraps,
      selectedPestEppoCode: selectedTraps.length > 0 ? selectedTraps[0].pestEppoCode ?? '' : undefined,
      selectedTrapIDs: selectedTraps.map(trap => trap.id)
    }),
  reset: () => set(getInitialState())
}));
